import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';

import { QueryContext } from './types';
import { COMPANY_FRAGMENT } from '../companyFragment';
import type { Company } from '../companyFragment';

export type QueryResponse = { errors: Error[] } | { Company: Company };

export const queryFn = async ({ queryKey: [_, companyId] }: QueryContext) => {
  const response = await requestWithAuth<QueryResponse>(
    gql`
      query getNarrativeValuationCompany($companyId: String!) {
        Company(id: $companyId) {
          ...CompanyFields
        }
      }
      ${COMPANY_FRAGMENT}
    `,
    { companyId }
  );

  if ('Company' in response) {
    return response.Company;
  }
};
